module.exports = __webpack_public_path__ + "static/the-man-who-fed-the-world-ed43a8c76cd7f5ee42bc467392f2cde2.jpg";